import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tiyeni_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function zmw(minor, { sign = false } = {}) {
  if (minor === null || minor === undefined) return "—";
  const neg = minor < 0;
  const abs = Math.abs(minor);
  const whole = Math.floor(abs / 100).toLocaleString("en-ZM");
  const cents = String(abs % 100).padStart(2, "0");
  return `${neg ? "−" : sign ? "+" : ""}ZMW ${whole}.${cents}`;
}

export function dt(s) {
  if (!s) return "—";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  return d.toLocaleString("en-GB", { timeZone: "Africa/Lusaka", day: "2-digit", month: "short", year: "numeric", ...(s.length > 10 ? { hour: "2-digit", minute: "2-digit" } : {}) });
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function openFile(fileId) {
  const { data } = await api.get(`/files/${fileId}/link`);
  window.open(`${process.env.REACT_APP_BACKEND_URL}${data.url}`, "_blank", "noopener");
}

export async function uploadFile(file, kind) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const { data } = await api.post("/files", fd);
  return data;
}

export const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Africa/Lusaka" });
